module.exports = __webpack_public_path__ + "img/banner_training.a1262285.jpg";